export abstract class PaginatedSectionBase<T> {
  readonly pageSizeOptions = [4, 8, 12];
  pageSize = 4;
  currentPage = 1;

  protected filteredItems: T[] = [];

  protected setFilteredItems(items: T[]): void {
    this.filteredItems = items;
    this.clampCurrentPage();
  }

  get visibleItems(): T[] {
    return this.filteredItems.slice(this.startIndex, this.startIndex + this.pageSize);
  }

  get startIndex(): number {
    return (this.currentPage - 1) * this.pageSize;
  }

  get displayResults(): number {
    return this.filteredItems.length;
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.filteredItems.length / this.pageSize));
  }

  get canGoPrev(): boolean {
    return this.currentPage > 1;
  }

  get canGoNext(): boolean {
    return this.currentPage < this.totalPages;
  }

  onPageSizeChange(rawValue: string): void {
    const nextSize = Number(rawValue);
    if (!Number.isFinite(nextSize) || nextSize <= 0) {
      return;
    }

    this.pageSize = nextSize;
    this.currentPage = 1;
    this.clampCurrentPage();
  }

  goToPrevPage(): void {
    if (this.canGoPrev) {
      this.currentPage -= 1;
    }
  }

  goToNextPage(): void {
    if (this.canGoNext) {
      this.currentPage += 1;
    }
  }

  protected clampCurrentPage(): void {
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    this.currentPage = Math.max(1, this.currentPage);
  }
}
